import { render, staticRenderFns } from "./FirewallRules.vue?vue&type=template&id=fa5789f8&scoped=true"
import script from "./FirewallRules.vue?vue&type=script&lang=js"
export * from "./FirewallRules.vue?vue&type=script&lang=js"
import style0 from "./FirewallRules.vue?vue&type=style&index=0&id=fa5789f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5789f8",
  null
  
)

export default component.exports